import EventEmitter from 'eventemitter3';
import { Settings } from '../Settings';
import { MediaPlayer } from '../engine/mediaplayer/MediaPlayer';
import { Heartbeat, Leave } from '../proto/messages';
import { StreamrWrapper } from './helpers/StreamrWrapper';
export class StreamrTvViewer extends EventEmitter {
    streamrWrapper;
    mediaPlayer;
    heartbeatTimeoutId;
    heartbeatIntervalId;
    audioMuted = true;
    screenSharing = false;
    videoProperties;
    constructor() {
        console.log('StreamrTvViewer constructor');
        super();
        this.streamrWrapper = new StreamrWrapper();
        this.mediaPlayer = new MediaPlayer();
        this.streamrWrapper.on('mediaPacketFragment', (packet) => {
            this.mediaPlayer.feedMediaPacketFragment(packet);
        });
        this.streamrWrapper.on('viewerInfo', (viewerInfo) => {
            this.emit('viewerInfoChanged', viewerInfo);
        });
        this.mediaPlayer.on('audioMuted', () => {
            this.audioMuted = true;
            this.emit('muteChange', true);
        });
        this.mediaPlayer.on('audioUnmuted', () => {
            this.audioMuted = false;
            this.emit('muteChange', false);
        });
        this.mediaPlayer.on('videoPropertiesChanged', (value) => {
            this.videoProperties = value;
            this.emit('videoPropertiesChanged', value);
        });
    }
    async start(streamPartId, canvas) {
        console.log('StreamrTvViewer::start()', streamPartId);
        await this.streamrWrapper.start(`${streamPartId}#0`);
        await this.mediaPlayer.start(canvas);
        this.setupHeartbeat();
    }
    async stop() {
        console.log('StreamrTvViewer::stop()');
        if (this.heartbeatTimeoutId) {
            window.clearTimeout(this.heartbeatTimeoutId);
        }
        if (this.heartbeatIntervalId) {
            window.clearInterval(this.heartbeatIntervalId);
        }
        window.removeEventListener('beforeunload', this.onBeforeUnload);
        this.sendLeave();
        await this.streamrWrapper.stop();
    }
    muteAudio() {
        this.mediaPlayer.mute();
    }
    unmuteAudio() {
        this.mediaPlayer.unmute();
    }
    isAudioMuted() {
        return this.audioMuted;
    }
    getVideoProperties() {
        return this.videoProperties;
    }
    sendLeave = () => {
        const leave = Leave.create({
            nodeId: this.streamrWrapper.getNodeId(),
        });
        this.streamrWrapper.publishLeave(leave);
    };
    sendHeartbeat = () => {
        const heartbeat = Heartbeat.create({
            nodeId: this.streamrWrapper.getNodeId(),
        });
        this.streamrWrapper.publishHeartbeat(heartbeat);
    };
    onBeforeUnload = () => {
        if (this.streamrWrapper) {
            this.sendLeave();
        }
    };
    setupHeartbeat() {
        window.addEventListener('beforeunload', this.onBeforeUnload);
        // Send first heartbeat immediately
        this.sendHeartbeat();
        /**
         * Send next scheduled heartbeat after a random
         * delay between 0 and the default interval to avoid
         * all nodes sending heartbeats at the same time
         */
        const randomDelay = Math.floor(Math.random() * Settings.defaultHeartbeatInterval);
        this.heartbeatTimeoutId = window.setTimeout(() => {
            this.heartbeatTimeoutId = undefined;
            this.sendHeartbeat();
            if (this.heartbeatIntervalId) {
                window.clearInterval(this.heartbeatIntervalId);
            }
            // Send the subsequent heartbeats at the default interval
            this.heartbeatIntervalId = window.setInterval(() => {
                this.sendHeartbeat();
            }, Settings.defaultHeartbeatInterval);
        }, randomDelay);
    }
}
